import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Responsável Patrimônio',
    path: '/patrimonio/patresponsavel/:gesEscolaId?',
    name: 'patresponsavel',
    component: () => import('@/views/patrimonio/patresponsavel/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RESPONSAVELPATRIMONIONOVO_MENU_1200300599],
    },
    goesToMenu: true,
  },
]
